import React from 'react';
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';

interface EntryRequirementNoticeProps {
  text: string;
}

/** Highlighted condition-of-entry box (e.g. photo ID policy) shown at the top of sign-up forms. */
export const EntryRequirementNotice: React.FC<EntryRequirementNoticeProps> = ({ text }) => (
  <div
    id="entry-requirement"
    role="note"
    className="bg-amber-50 border-2 border-amber-400 rounded-lg p-4 mb-4"
  >
    <div className="flex items-start">
      <ExclamationTriangleIcon className="h-6 w-6 text-amber-600 mr-3 flex-shrink-0" aria-hidden="true" />
      <div>
        <p className="text-amber-900 font-semibold uppercase tracking-wide text-xs mb-1">
          Condition of entry
        </p>
        <p className="text-amber-900 text-sm whitespace-pre-wrap">{text}</p>
      </div>
    </div>
  </div>
);

interface EntryRequirementCheckboxProps {
  id: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
}

/** Required tick box confirming the attendee will comply with the condition of entry. */
export const EntryRequirementCheckbox: React.FC<EntryRequirementCheckboxProps> = ({ id, checked, onChange }) => (
  <div className="flex items-start bg-amber-50 border border-amber-300 rounded-md p-3">
    <input
      type="checkbox"
      id={id}
      required
      checked={checked}
      onChange={(e) => onChange(e.target.checked)}
      className="h-4 w-4 text-amber-600 focus:ring-amber-500 border-gray-300 rounded mt-1"
    />
    <label htmlFor={id} className="ml-2 text-sm text-amber-900">
      I have read the <a href="#entry-requirement" className="underline font-medium">condition of entry</a> above
      and confirm I will comply with it. I understand I will not be admitted otherwise.
      {' '}<span className="text-red-500">*</span>
    </label>
  </div>
);
